import React, { useState, useEffect } from 'react';
import './ToggleButton.css';

const ToggleButton = ({
  defaultState = false,
  checked,
  onToggle,
  disabled = false,
  className = '',
}) => {
  const isControlled = checked !== undefined;
  const [internalToggled, setInternalToggled] = useState(defaultState);
  const isToggled = isControlled ? checked : internalToggled;

  useEffect(() => {
    if (!isControlled) {
      setInternalToggled(defaultState);
    }
  }, [defaultState, isControlled]);

  const handleToggle = () => {
    if (disabled) return;

    const newState = !isToggled;
    if (!isControlled) {
      setInternalToggled(newState);
    }
    if (onToggle) {
      onToggle(newState);
    }
  };

  return (
    <div
      className={`toggle-button ${isToggled ? 'active' : ''} ${disabled ? 'disabled' : ''} ${className}`.trim()}
      onClick={handleToggle}
      role="switch"
      aria-checked={isToggled}
      aria-disabled={disabled}
    >
      <div className="toggle-circle"></div>
    </div>
  );
};

export default ToggleButton;